import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PermitValue, permitKey } from "constants";
import Utils from "utils";
import { getFreshAuthToken } from "auth/FetchInterceptor";
import { authenticated, signOutApi } from "store/slices/authSlice";

// Gom cau hinh runtime cua chat (token, user, endpoint, quyen nhom) vao mot cho.
// ChatSurface (modal + trang full) va ChatRail (widget neo mep phai) deu dung chung,
// de hai noi khong bao gio lech cau hinh khi mot ben duoc sua.
const useChatRuntimeProps = () => {
  const dispatch = useDispatch();
  const { token, profile, permitList, expireTime } = useSelector(
    (state) => state.auth
  );

  const onRefreshToken = useCallback(async () => {
    try {
      const newToken = await getFreshAuthToken();
      dispatch(authenticated(newToken));
      return newToken;
    } catch (error) {
      dispatch(signOutApi());
      throw error;
    }
  }, [dispatch]);

  const onUnauthorized = useCallback(() => {
    dispatch(signOutApi());
  }, [dispatch]);

  const hasAddGroupVerified = Utils.checkPermitValue(
    PermitValue.them,
    permitList,
    permitKey.hrm_chatGroupVerified
  );

  const hasUpdateGroupVerified = Utils.checkPermitValue(
    PermitValue.sua,
    permitList,
    permitKey.hrm_chatGroupVerified
  );

  const hasDeleteGroupVerified = Utils.checkPermitValue(
    PermitValue.xoa,
    permitList,
    permitKey.hrm_chatGroupVerified
  );

  const hasViewGroupVerified = Utils.checkPermitValue(
    PermitValue.xem,
    permitList,
    permitKey.hrm_chatGroupVerified
  );
  
  return {
    // undefined khi chua dang nhap -> noi dung tu quyet dinh co render chat hay khong.
    userId: profile?.id,
    accessToken: token,
    expireTime,
    stickerBaseUrl: `${process.env.REACT_APP_MEDITECH_CHAT_STICKER_URL}`,
    apiUrl: `${process.env.REACT_APP_MEDITECH_CHAT_API_URL}`,
    socketUrl: `${process.env.REACT_APP_MEDITECH_CHAT_API_URL}`,
    inviteLinkBaseUrl: process.env.REACT_APP_CHAT_INVITE_BASE_URL || undefined,
    hasAddGroupVerified,
    hasUpdateGroupVerified,
    hasDeleteGroupVerified,
    hasViewGroupVerified,
    onRefreshToken,
    onUnauthorized,
  };
};

export default useChatRuntimeProps;
